import { Box, useTheme } from "@mui/material";
import React from "react";
import { Outlet } from "react-router-dom";
import SideMenu from "./SideMenu";
import Footer from "./Footer";
import Header from "./Header";

const Layout = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        width: "100vw",
        backgroundColor: theme.palette.background.default,
      }}
    >
      {/* Side Menu with higher z-index */}
      <Box sx={{ zIndex: 1000 }}>
        <SideMenu />
      </Box>

      {/* Main Content Area with Header */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          height: "100%",
          overflow: "hidden",
        }}
      >
        {/* Header positioned next to side menu */}
        <Header />

        {/* Main Content */}
        <Box
          sx={{
            flex: 1,
            height: "100%",
            overflow: "auto",
            backgroundColor: theme.palette.background.default,
            py: 1,
            px: 4,
          }}
        >
          <Outlet />
        </Box>

        {/* Footer */}
        <Footer />
      </Box>
    </Box>
  );
};

export default Layout;
